import { useEffect, useRef, useState } from "react";
import { MapPin } from "lucide-react";
import api from "../lib/api";

export const AddressSuggestInput = ({ value, onChange, onSelect, testid, placeholder, className, mode = "street", citta = "", coords = null }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const timer = useRef(null);
  const skip = useRef(false);

  useEffect(() => {
    if (skip.current) { skip.current = false; return; }
    clearTimeout(timer.current);
    const q = value.trim();
    const minLen = mode === "cap" ? 2 : 3;
    if (q.length < minLen) { setSuggestions([]); setOpen(false); return; }
    timer.current = setTimeout(async () => {
      try {
        const params = { q, mode, citta };
        if (coords?.lat && coords?.lon) { params.lat = coords.lat; params.lon = coords.lon; }
        const { data } = await api.get("/geo/search", { params });
        setSuggestions(data);
        setOpen(data.length > 0);
      } catch { /* silenzioso */ }
    }, 400);
    return () => clearTimeout(timer.current);
  }, [value, mode, citta, coords]);

  const pick = (s) => {
    skip.current = true;
    setOpen(false);
    setSuggestions([]);
    onSelect(s);
  };

  const mainLine = (s) => {
    if (mode === "city") return `${s.citta}${s.provincia ? ` (${s.provincia})` : ""}`;
    if (mode === "cap") return `${s.cap}${s.citta ? ` — ${s.citta}` : ""}${s.provincia ? ` (${s.provincia})` : ""}`;
    return `${s.via}${s.civico ? ` ${s.civico}` : ""}${s.citta ? `, ${s.citta}` : ""}`;
  };

  return (
    <div className="relative">
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => setTimeout(() => setOpen(false), 200)}
        onFocus={() => suggestions.length > 0 && setOpen(true)}
        placeholder={placeholder}
        data-testid={testid}
        autoComplete="off"
        className={className}
      />
      {open && (
        <div className="absolute left-0 top-full z-30 mt-1.5 max-h-56 w-full min-w-64 overflow-y-auto rounded-xl border border-ink/10 bg-panel shadow-xl" data-testid={`${testid}-suggestions`}>
          {suggestions.map((s, i) => (
            <button
              key={i}
              type="button"
              onMouseDown={(e) => { e.preventDefault(); pick(s); }}
              data-testid={`${testid}-suggestion-${i}`}
              className="flex w-full items-start gap-2 px-4 py-2.5 text-left text-sm text-ink transition-colors hover:bg-cream"
            >
              <MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0 text-sage" />
              <span className="min-w-0">
                <span className="block truncate font-medium">{mainLine(s)}</span>
                <span className="block truncate text-xs text-ink-soft">{s.label}</span>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
